import { useEffect } from "react";
import { createPortal } from "react-dom";

import CloseButton from "../../../../../Components/UI/CloseButton/CloseButton";
import Content from "../AllDetails/Content/Content";
import ThreatsTable from "../AllDetails/ThreatsTable/ThreatsTable";
import SigmaMatchPanel from "../AllDetails/SigmaMatchPanel/SigmaMatchPanel";
import DetectionSandboxSubmit from "./DetectionSandboxSubmit";

import "./styles.scss";

const DetectionDetailPopup = ({ item, onClose }) => {
  useEffect(() => {
    const escapeKeyDownHandler = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };

    document.addEventListener("keydown", escapeKeyDownHandler);

    // Disable background page scrolling while the popup is open
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", escapeKeyDownHandler);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  if (!item) return null;

  return createPortal(
    <div className="thunter-detail-popup" onClick={onClose}>
      <div className="thunter-detail-popup__card border" onClick={(e) => e.stopPropagation()}>
        <div className="thunter-detail-popup__close">
          <CloseButton onClick={onClose} />
        </div>
        <Content item={item} rightHeader={<DetectionSandboxSubmit item={item} />}>
          {item.engine !== "sigma" ? (
            <ThreatsTable threats={item.threats || []} />
          ) : (
            <SigmaMatchPanel match={item.threats?.[0] || {}} />
          )}
        </Content>
      </div>
    </div>,
    document.body,
  );
};

export default DetectionDetailPopup;
